module.exports = __webpack_public_path__ + "static/media/21ECLAC33.36cef191.jpg";